module.exports = __webpack_public_path__ + "img/card-close.4249544e.svg";